import React from 'react';

export const NoTableDataPlaceholder = () => (
  <div className="pointer-events-none absolute inset-0 flex items-center justify-center text-grey">
    No Data
  </div>
);
